import React, {Component} from 'react';

class ServiceSubscribe extends Component {
    render(){
        let {sClass} = this.props;
        return(
            <div>
                <div className="row mt_50 mb_50 justify-content-center" >
                    <div className="col-lg-8 text-center p-4 border border-secondary">
                        <div className={`text-center  ${sClass}`}>
                            <h2 className="hemdahl-text-dark hemdahl-text-md mb_20 ps-5 pe-5">Find out about our latest features and updates by subscribing to our monthly newsletter.</h2>
                            <form action="https://hemdahl.us20.list-manage.com/subscribe/post?u=fac48131da2c68cd26fee1f3e&amp;id=08db735712"
                                method="post" id="mc-embedded-subscribe-form"
                                name="mc-embedded-subscribe-form"
                                class="validate" target="_blank" novalidate
                                className="subscribe-form">
                                <input type="email"  name="EMAIL"
                                        class="email" id="mce-EMAIL"
                                        placeholder="Enter your email address"/>
                                <div style={{position: 'absolute', left: '-5000px', ariaHidden: "true"}}>
                                    <input type="text" name="b_fac48131da2c68cd26fee1f3e_08db735712" tabindex="-1" value=""/>
                                </div>
                                <div className="row justify-content-center" >
                                    <div className="col-lg-7 text-center p-4">
                                        <button type="submit" name="subscribe" id="mc-embedded-subscribe" className="btn_get btn_hover new_btn mt-0 ms-4">
                                            Subscribe
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
         )
    }
}
export default ServiceSubscribe;